import { render } from "./MailLogs.vue?vue&type=template&id=d716bee4&scoped=true"
import script from "./MailLogs.vue?vue&type=script&lang=js"
export * from "./MailLogs.vue?vue&type=script&lang=js"

import "./MailLogs.vue?vue&type=style&index=0&id=d716bee4&scoped=true&lang=css"

import exportComponent from "/home/projects/frontend.vendor-mailing-system.pravin/vendor-mailig-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d716bee4"]])

export default __exports__